import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import { SettingsFacilitiesRoute } from './SettingsFacilitiesRoute';
import { SettingsFacilityBorrowingBaseConfigurationRoute } from './SettingsFacilityBorrowingBaseConfigurationRoute';
import { SettingsFacilityBorrowingBaseLoanTapeRoute } from './SettingsFacilityBorrowingBaseLoanTapeRoute';
import { SettingsFacilityBorrowingBaseSandboxRoute } from './SettingsFacilityBorrowingBaseSandboxRoute';
import { SettingsUserRoute } from './SettingsUserRoute';

export const SettingsRouter = withLDConsumer()(({ flags }) => {
  const displayLenderSettingsFacilities = !!flags?.displayLenderSettingsFacilities;
  const enableLenderBaseFieldEdits =
    displayLenderSettingsFacilities && !!flags?.enableLenderBaseFieldEdits;

  return (
    <Switch>
      <Route exact path="/settings/my-account" component={SettingsUserRoute} />
      {displayLenderSettingsFacilities && (
        <Route
          exact
          path="/settings/facilities"
          component={SettingsFacilitiesRoute}
        />
      )}
      {displayLenderSettingsFacilities && (
        <Route exact path="/settings/facilities/borrowing-base/configuration">
          <SettingsFacilityBorrowingBaseConfigurationRoute />
        </Route>
      )}
      {displayLenderSettingsFacilities && (
        <Route exact path="/settings/facilities/borrowing-base/sandbox">
          <SettingsFacilityBorrowingBaseSandboxRoute />
        </Route>
      )}
      {enableLenderBaseFieldEdits && (
        <Route exact path="/settings/facilities/borrowing-base/loantape">
          <SettingsFacilityBorrowingBaseLoanTapeRoute />
        </Route>
      )}

      {displayLenderSettingsFacilities && (
        <Route exact path="/settings/facilities/borrowing-base">
          <Redirect
            from="/settings/facilities/borrowing-base"
            to="/settings/facilities/borrowing-base/configuration"
          />
        </Route>
      )}
      <Route exact path="/settings">
        <Redirect from="/settings" to="/settings/my-account" />
      </Route>
    </Switch>
  );
});
